/**
 * @file app-feedback.schema.ts
 * @description Schema Zod para a entidade 'AppFeedback'.
 * Cada documento representa o feedback (rating 1-5 + comentário) que um
 * usuário deu sobre o app dentro do perfil. One-shot: há no máximo um
 * documento por usuário.
 *
 * Esta coleção alimenta KPIs e a lista de comentários no dashboard admin
 * (médias, distribuição de estrelas, comentários paginados).
 */

import { z } from 'zod';

// --- Main Schema ---

const AppFeedbackSchema = z.object({
  id: z.string(),

  // Identificação do usuário e contexto desnormalizado (para filtros no admin)
  userId: z.string(),
  pregnancyId: z.string().nullable(),
  partnerId: z.string().nullable(),

  // Nota de 1 a 5 estrelas
  rating: z.number().int().min(1).max(5),

  // Comentário obrigatório (max 2000 chars)
  comment: z.string().min(1).max(2000),

  // Auditoria
  createdAt: z.date(),
  updatedAt: z.date(),
});


// --- Inferred TypeScript Types ---

type AppFeedback = z.infer<typeof AppFeedbackSchema>;


// --- Public Exports ---

export { AppFeedbackSchema };
export type { AppFeedback };
